<mapfre-card [singleCard]="false" [additionalClasses]="'contact details'">
  <section class="details-content row no-margin">
    <ng-container *ngIf="isAcmic; else MAstate">
      <div class="col">
        <div class="row margin-bottom mb24">
          <div class="col">
            <h2 class="title contact_black margin-bottom mb16">
              {{ "NEED_HELP" | translate }}
            </h2>
            <div>
              <p>
                {{ "CONTACT_OUR_EXCEPTIONAL_CUSTOMER_SERVICE" | translate }}
              </p>
              <ul>
                <li>
                  {{ "POLICY_CHANGES_COVERAGES_DISC_INFO" | translate }}
                </li>
                <li>
                  {{ "BILLING_INFO" | translate }}
                </li>
                <li>
                  {{ "NEW_EXISTING_CLAIMS" | translate }}
                </li>
              </ul>
            </div>
            <div>
              <p>
                <strong>{{ "CALL_US" | translate }}:
                  <span>
                    <a href="tel:18442954500" class="underlineBQ mapfre link blue-link">1-844-295-4500</a>
                  </span>
                </strong>
              </p>
              <p>{{ "NEW_CONTACT_CENTER_HOURS" | translate }}</p>
            </div>

            <div class="margin-top mt4">
              <app-billing-question></app-billing-question>
            </div>
          </div>
        </div>

        <div class="row margin-bottom mb24">
          <div class="col">
            <h2 class="title contact_black margin-bottom mb16">
              {{ "TO_MAIL_A_PAYMENT_OR_CORRESPONDENCE" | translate }}
            </h2>
            <div class="row">
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="font-bold fake-black-color">
                  {{ "PAYMENT_TITLE" | translate }}
                </h6>

                <span class="fs-12">{{
                  "AUTO_CLUB_MAPFRE_PART1" | translate
                  }}</span>
                <br />
                <span class="fs-12">{{
                  "AUTO_CLUB_MAPFRE_PART2" | translate
                  }}</span>
              </div>
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="font-bold fake-black-color">
                  {{ "CORRESPONDENCE_TITLE" | translate }}
                </h6>
                <span class="fs-12">
                  {{ "AAA_INSURANCE_PART1" | translate }},<br />
                  {{ "POBOX_3" | translate }}, {{ "ADDRESS_PART_TWO" | translate }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!-- <ng-template #MAstate>
      <div class="col col1">
        <div
          style="display: block;"
          class="row margin-bottom mb24"
          *ngIf="both"
        >
          <mapfre-info-divs>
            <em>
              <div class="mb10">
                <b *ngIf="allLivoPolicy.length > 1">{{
                  "MULTIPLE_POLICY" | translate
                }}</b>
                <b *ngIf="allLivoPolicy.length === 1">{{
                  "SINGLE_POLICY" | translate
                }}</b>
              </div>
            </em>
            <div
              class="row policy-row mb-50"
              *ngFor="let policy of allLivoPolicy"
             >
              <div class="col-12 col-md-6">
                <ng-container>
                  <div style="display: flex;" class="mb10">
                    <div
                      class="policy-icon policy-icon-top float-left margin-right mr8 auto-svg"
                    >
                      <span
                        *ngIf="
                          policy.policyType === 'AUTO' ||
                          policy.policyType === 'COMMERCIAL_AUTO'
                        "
                        ><ng-container *ngIf="isAcmic; else nonAcmicCarIcon">
                          <img src="assets/img/images/icon-car-24.svg"  alt="car icon" />
                        </ng-container>
                        <ng-template #nonAcmicCarIcon>
                          <svg-car-mono-color-small-svg></svg-car-mono-color-small-svg>
                        </ng-template>
                      </span>
                      <span *ngIf="policy.policyType === 'HOME'"
                        ><ng-container *ngIf="isAcmic; else nonAcmicHomeIcon">
                          <img src="assets/img/images/icon-home-24.svg"  alt="home icon" />
                        </ng-container>
                        <ng-template #nonAcmicHomeIcon>
                          <svg-house-mono-color-small-svg></svg-house-mono-color-small-svg>
                        </ng-template>
                      </span>
                      <span *ngIf="policy.policyType === 'UMBRELLA'"
                        ><svg-umbrella-svg></svg-umbrella-svg
                      ></span>
                      <span *ngIf="policy.policyType === 'SCHEDULED_PROPERTY'"
                        ><ng-container *ngIf="isAcmic; else nonAcmicUmbrellaIcon">
                          <img src="assets/img/images/icon-umbrella-acmic.svg"  alt="umbrella icon" />
                        </ng-container>
                        <ng-template #nonAcmicUmbrellaIcon>
                          <svg-umbrella-svg></svg-umbrella-svg>
                        </ng-template>
                      </span>
                      <span
                        *ngIf="
                          policy.policyType === 'DWELLING_FIRE_PERSONAL' ||
                          policy.policyType === 'COMMERCIAL_FIRE'
                        "
                        ><svg-dwelling-fire-svg></svg-dwelling-fire-svg
                      ></span>
                      <span *ngIf="policy.policyType === 'GARAGE_KEEPER'"
                        ><svg-garage-svg></svg-garage-svg
                      ></span>
                      <span
                        *ngIf="
                          policy.policyType === 'GENERAL_LIABILITY' ||
                          policy.policyType === 'SPECIAL_MULTI_PERIL'
                        "
                        ><svg-liability-svg></svg-liability-svg
                      ></span>
                    </div>
                    <div class="policy-info">
                      <div class="policy-info-contents">
                        {{ policy?.displayType?.label | titlecase }}:
                      </div>
                    </div>
                    <div class="policyNumberBold">
                      <b>&nbsp;{{ policy?.policynumber.policyNumber }}</b>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <span>{{ "CONTACT_US_AT" | translate }}</span
            ><b
              ><a href="tel:18556273737" class="mapfre link red-link dm-sans-medium underline"
                >1-855-627-3737</a
              ></b
            >
          </mapfre-info-divs>
        </div>
        <div class="row margin-bottom mb32">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
              {{ "NEW_AND_EXISTING_CLAIMS" | translate }}
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" *ngIf="showCompany==='all'">
              {{ "For Massachusetts policies only" }}
            </div>
            <div>
              <ng-container *ngIf="showCompany==='ma' || showCompany==='all'">
              <span class="contact-claims">{{ "PHONE" | translate }}</span>
              
            
                <a
                *ngIf="livoNumber"
                href="tel:18556273737"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >1-855-627-3737</a
              ><span *ngIf="as400Number"
                ><a
                  href="tel:18009228276"
                  class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                  >1-800-922-8276</a
                > </span
                > 
             
              <div class="info dm-sans-medium font-weight-500 mb-3 mt-1">{{ "AVAILABLE_24_7" | translate }}</div>
            </ng-container>
              <ng-container *ngIf="showCompany!=='ma'">
                <ng-container *ngIf="showCompany==='all'">
                  <div class="dm-sans-medium font-class font-weight-500 med-grey font-small">
                    {{ "For all other states outside of Massachusetts" }}
                  </div>
                </ng-container>
                <span class="contact-claims">{{ "PHONE" | translate }}</span>
                <a
                href="tel:18776273731"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >1-877-Mapfre1 (1-877-627-3731)</a>
                <div class="info dm-sans-medium font-weight-500 mb-3 mt-1">{{ "AVAILABLE_24_7" | translate }}</div>
              </ng-container>                
               
              
              <ng-container *ngIf="showCompany==='ma'">
              <span class="contact-claims">{{ "FAQ_NEW" | translate }}</span
              ><span class="font-class brand-blue-secondary">{{ "FAQ_MSG" | translate }}</span
              ><a
                routerLink="/claims"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >{{ "CLAIM_AREA" | translate }}</a
              >
            </ng-container>
            </div>
          </div>
        </div>

        <div class="row margin-bottom mb32">
          <div class="col">
            <h2 class="title margin-bottom mb16 mt-3 dm-sans-medium font-weight-500">
              {{ "BILLING_CUSTOMER_SERVICE_QUOTES" | translate }}
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" *ngIf="showCompany==='all'">
              {{ "For Massachusetts policies only" }}
            </div>
            <ng-container *ngIf="showCompany==='ma' || showCompany==='all'">
              <div>
              <span class="contact-claims">{{ "PHONE" | translate }}</span>
              
                <a
                *ngIf="livoNumber"
                href="tel:18556273737"
                class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                >1-855-627-3737</a
              ><span *ngIf="as400Number"
                ><a
                  href="tel:18009228276"
                  class="mapfre link red-link dm-sans-medium font-weight-500 underline"
                  >1-800-922-8276</a
                ></span
              >
              <div class="info margin-bottom mb4 mt-1 dm-sans-medium font-weight-500 contact-center-wide">
                {{ "CONTACT_CENTER_HOURS" | translate }} |
                {{ "CONTACT_CENTER_HOURS_2" | translate }} {{ "(EST)" }}
              </div>
              <div class="info mt-1 dm-sans-medium font-weight-500 contact-center-mobile">
                {{ "CONTACT_CENTER_HOURS" | translate }}
              </div>
              <div class="info dm-sans-medium font-weight-500 contact-center-mobile">
                {{ "CONTACT_CENTER_HOURS_2" | translate }} {{ "(EST)" }}
              </div>
              <div class="margin-top mt16">
                <app-billing-question></app-billing-question>
              </div>
            </div>
          </ng-container>  

            <ng-container *ngIf="showCompany!=='ma'">
              <ng-container *ngIf="showCompany==='all'">
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-top mt16">
                  {{ "For all other states outside of Massachusetts" }}
                </div>
              </ng-container>
                <span class="contact-claims">{{ "PHONE" | translate }}</span>
              <a
              href="tel:18776273731"
              class="mapfre link red-link dm-sans-medium font-weight-500 underline"
              >1-877-Mapfre1 (1-877-627-3731)</a>
              <div class="info margin-bottom mb4 mt-1 dm-sans-medium font-weight-500 contact-center-wide">
                {{ "Monday to Friday 8am to 8pm (EST)" | translate }}
              </div>
            </ng-container>       

          </div>
        </div>
        
        <div class="row margin-bottom mb16">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
              {{ "TO_MAIL_A_PAYMENT_OR_CORRESPONDENCE" | translate }}
            </h2>
            <div class="row fake-black-color">
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="dm-sans-medium font-weight-500">
                  {{ "PAYMENT_TITLE" | translate }}
                </h6>
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" [ngClass]="{'col-9CB0BC lh-16 margin-bottom mb8':!isAcmic}">
                  {{ "FOR_OTHER_STATES_OUTSIDE_CALIFORNIA" | translate }}
                </div>
                <span class="dm-sans-medium font-weight-500" [ngClass]="{'lh-16 font-weight-700 margin-bottom mb8':!isAcmic}">{{ "COMPANY_NAME" | translate }}</span
                >
                <span class="font-class addr-block">{{ "POBOX_1" | translate }}</span>
                <span class="font-class addr-block">{{ "POBOX_2" | translate }}</span>
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-top mt16" [ngClass]="{'col-9CB0BC lh-16 margin-bottom mb8':!isAcmic}">
                  {{ "FOR_CALIFORNIA_POLICIES_ONLY" | translate }}
                  </div>
                  <span class="dm-sans-medium font-weight-500" [ngClass]="{'lh-16 font-weight-700 margin-bottom mb8':!isAcmic}">{{ "COMPANY_NAME" | translate }}</span
                    >
                    <span class="font-class addr-block">{{ "POBOX" | translate }}{{ "52234" }}</span>
                    <span class="font-class addr-block">{{ "Phoenix, AZ 85072" }}</span>
              </div>
              <div class="col-md-6 col-12 margin-bottom mb16">
                <h6 class="dm-sans-medium font-weight-500 fake-black-color">
                  {{ "CORRESPONDENCE_TITLE" | translate }}
                </h6>
                <span class="dm-sans-medium font-weight-500" [ngClass]="{'font-weight-700 lh-16 margin-bottom mb8':!isAcmic}">{{ "COMPANY_NAME" | translate }}</span
                ><br />
                  <span class="font-class addr-block">
                    {{ "POBOX_3" | translate }}
                  </span>
                    <span class="font-class addr-block">
                    {{ "ADDRESS_PART_TWO" | translate }}
                    </span>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="col col2" [ngClass]="{'no-margin-top': !isAcmic}">
        <div class="row">
          <div class="col">
            <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
              <ng-container *ngIf="policies?.length === 1; else multipleAgents">
                <div>{{ "CONTACT_YOUR_AGENT" | translate }}</div>
              </ng-container>
              <ng-template #multipleAgents>
                <div>{{ "CONTACT_YOUR_AGENTS" | translate }}</div>
              </ng-template>
            </h2>
            <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-bottom mb8" [ngClass]="{'contact-agent-text margin-bottom mb16': !isAcmic}">
              {{ "FOR_POLICY_CHANGES_COVERAGES_DISCOUTS" | translate }}
            </div>
            <ng-container *ngIf="loading">
              <mapfre-loading></mapfre-loading>
            </ng-container>
            <div *ngIf="!loading">
              <ng-container *ngFor="let policy of policies; index as key">
                <ng-container *ngIf="!policy[0]?.isNewPolicy">
                  <div class="agent-info  margin-bottom mb32">
                    <div class="row agent-name margin-bottom mb8 dm-sans-medium font-weight-500">
                      <div class="col">
                        {{ policy[0]?.agent?.agentName }}
                      </div>
                    </div>
                    <div class="row agent-address margin-bottom mb8" *ngIf="policy[0]?.agent?.address">
                      <div class="col">
                        {{ policy[0]?.agent?.address?.streetName | titlecase }}
                        {{ policy[0]?.agent?.address?.city | titlecase }}
                        {{ policy[0]?.agent?.address?.stateCode }},
                        {{ policy[0]?.agent?.address?.zipCode?.code }}
                      </div>
                    </div>
                    <div
                      class="row agent-phone margin-bottom mb8"
                      *ngIf="policy[0]?.agent?.agentISCPhone?.number"
                    >
                      <div class="col col-description">
                        <span class="contact-claims">{{ "PHONE" | translate }}</span>
                      </div>
                      <div class="col col-info">
                        <a
                          href="tel:{{ policy[0]?.agent.agentISCPhone.number }}"
                          class="mapfre link underline red-link dm-sans-medium font-weight-700"
                          >{{
                            policy[0]?.agent?.agentISCPhone?.number
                              | formatPhone
                          }}</a
                        >
                      </div>
                    </div>
                    <div
                      class="row agent-phone margin-bottom mb8"
                      *ngIf="
                        policy[0]?.agent?.agentPhone?.number &&
                        !policy[0]?.agent?.agentISCPhone?.number
                      "
                    >
                      <div class="col col-description">
                        <span class="contact-claims">{{ "PHONE" | translate }}</span>
                      </div>
                      <div class="col col-info">
                        <a
                          href="tel:{{ policy[0]?.agent.agentPhone.number }}"
                          class="mapfre link underline red-link dm-sans-medium font-weight-700"
                          >{{
                            policy[0]?.agent?.agentPhone?.number | formatPhone
                          }}</a
                        >
                      </div>                     
                    </div>
                    <div 
                      class="row agent-email margin-bottom mb8"
                      *ngIf="policy[0]?.agent?.agentEmail && policy[0]?.agent?.agentEmail.trim().length > 0"
                    >
                      <div class="col col-description">
                        {{ "EMAIL" | translate }}:
                      </div>
                      <div class="col col-info">
                        <a href="mailto:{{ policy[0]?.agent?.agentEmail }}"
                          class="mapfre link underline red-link dam-sans-medium font-weight-700"
                          >{{ policy[0]?.agent?.agentEmail }}</a>
                      </div>
                    </div>
                    <div class="dm-sans-medium font-class font-weight-500 med-grey font-small" [ngClass]="{'contact-agent-text contact-agent-space': !isAcmic}">
                      <ng-container *ngIf="policy.length<=1">
                         {{ "Policy number" }} 
                      </ng-container>
                      <ng-container *ngIf="policy.length>1"> 
                          {{ "Policy numbers" }}
                      </ng-container>
                    </div>
                    <ng-container *ngFor="let pol of policy">
                      <div class="row policy-info margin-bottom mb8">
                        <div class="col">
                          <div class="display-inline fs-14 margin-right mr8">
                            {{ pol?.displayType?.label | translate }}
                          </div>
                          
                          <div class="display-inline "> 
                            <span class="fs-14 ">
                              <strong>{{pol?.policynumber?.policyNumber}}</strong>
                            </span>
                        </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="showCompany!=='ma' && showCompany!=='all' ">
                <h2 class="title margin-bottom mb16 dm-sans-medium font-weight-500">
                    <div>{{ "Billing Question" | translate }}</div>
                </h2>
                <div class="dm-sans-medium font-class font-weight-500 med-grey font-small margin-bottom mb8">
                  {{ "Have a question about this policy?" | translate }}
                </div>
                <div class="margin-top mt16">
                  <app-billing-question [isLegacy]="true"></app-billing-question>
                </div>
              </ng-container>

            </div>
          </div>
        </div>
      </div> 
    </ng-template> -->
    <ng-template #MAstate>
      <p class="contact-new-heading" [ngClass]="{'margin-bottom mb24': companyDomain === 'V12'}">Contact us</p>
      <div class="new-contact-container">
        <div class="first-container">
          <div>
            <div class="margin-bottom mb8">
              <p class="customer-service">Customer service</p>
            </div>
            <div class="phone-details" *ngIf="companyDomain === 'AS400' || ( (policyData[0]?.policynumber?.policyNumber?.length === 10 && policyData[0]?.jurisdiction?.state === 'MA') && (!(companyDomain === 'TW' || companyDomain === 'V12')) &&  policies?.length > 1)">
              <div class="phone margin-right mr8">Phone</div>
              <div class="helpline-two" *ngIf="companyDomain === 'AS400'">[(1-877-627-3731)]</div>
              <div class="helpline-two" *ngIf="( (policyData[0]?.policynumber?.policyNumber?.length === 10 && policyData[0]?.jurisdiction?.state === 'MA') && (!(companyDomain === 'TW' || companyDomain === 'V12')) &&  policies?.length > 1)">[(1-877-627-3737)]</div>
            </div>
            <div class="phone-details" *ngIf="companyDomain === 'TW' || companyDomain === 'V12' || (hasAcicPolicy && hasTwPolicy)"> 
              <div class="phone margin-right mr8">Phone</div>
              <div class="helpline-container">
                <div class="helpline-one">[1-877-Mapfre1]</div>
                <div class="helpline-two">[(1-877-627-3731)]</div>
              </div>
            </div>          
            <div class="phone-details" *ngIf="((policyData[0]?.policynumber?.policyNumber?.length === 10 || companyDomain === 'AS400') &&  policyData?.jurisdiction?.state === 'MA' )  && (companyDomain === 'TW' || companyDomain === 'V12')">
              <div>
                <div class="phone-details-heading">For MA policies only</div>
                <div class="phone-details-container">
                  <div class="phone margin-right mr8">Phone</div>
                  <div class="helpline-two">[(1-877-627-3737)]</div>
                </div>
              </div>
              <div class="phone-details-hr"></div>
              <div>
                <div class="phone-details-heading">For all other states</div>
                <div class="phone-details-container">
                  <div class="phone margin-right mr8">Phone</div>
                  <div class="helpline-one">[1-877-Mapfre1]</div>
                  <div class="helpline-two">[(1-877-627-3731)]</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <p class="contact-billing-heading">Billing & policy support hours</p>
            </div>
            <ng-container *ngIf="((policyData[0]?.policynumber?.policyNumber?.length === 10 || companyDomain === 'AS400') &&  policyData?.jurisdiction?.state === 'MA' )  && (companyDomain === 'TW' || companyDomain === 'V12'); else otherPolicies">
              <div class="contact-billing-container">
                <div>
                  <p class="contact-billing-content-heading">For MA policies only</p>
                  <p class="contact-billing-content">Mon-Fri: 7am-9pm | <br *ngIf="isSmallScreen">Sat: 8am-5pm EST</p>
                </div>
                <div class="contact-billing-hr"></div>
                <div>
                  <p class="contact-billing-content-heading">For all other states</p>
                  <p class="contact-billing-content">Mon-Fri: 7am-9pm</p>
                </div>
              </div>
            </ng-container>
            <ng-template #otherPolicies>
              <div>
                <p class="contact-billing-content">Mon-Fri: 7am-9pm | <br *ngIf="isSmallScreen">Sat: 8am-5pm EST</p>
              </div>
            </ng-template>
          </div>
          <div>
            <div>
              <p class="contact-claim-heading">Claim assistance support hours</p>
            </div>
            <div>
              <p class="contact-claim-content">Available 24/7</p>
            </div>
          </div>
        </div>
      </div>
      <div class="contact-agent-container" [ngClass]="{'margin-bottom mb24 margin-top mt24': companyDomain === 'V12'}">
        <a class="faq-link-item" (click)="closeNonActiveCollapse('one')" mdbRipple
          [class.active]="accordianWithMDB.one">
          <div class="faq-item">
            <div class="contact-agent-title">Contact your agent(s)</div>
            <div class="faq-arrow-block">
              <img src="assets/img/images/contact-icon-arrow-right.svg" *ngIf="!accordianWithMDB.one"
                alt="simple down arrow" />
              <img src="assets/img/images/contact-icon-arrow-down.svg" *ngIf="accordianWithMDB.one"
                alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div #one [class.fake-accourdian]="!accordianWithMDB.one">
          <div class="faq-answ-block no-padding-top">
            <ng-container *ngFor="let policy of policies; index as key ; let last = last">
              <ng-container *ngIf="!policy[0]?.isNewPolicy">
                <div class="contact-agent-info" [ngClass]="{'padding-bottom pb-2': !last}">
                  <div class="contact-agent-info-hr"></div>
                  <div class="contact-agent-heading-container">
                    <div class="contact-agent-heading">
                      {{ policy[0]?.agent?.agentName }}
                    </div>
                  </div>
                  <div class="contact-agent-subcontainer" [ngClass]="{'contact-policy-type-container-gap': policies?.length>1 && !isSmallScreen }">
                    <ng-container *ngIf="isSmallScreen else bigScreen">
                      <div>
                        <ng-container *ngFor="let pol of policy">
                          <div class="contact-policy-type-container">
                            <div class="contact-policy-type">
                              <div class="contact-policy-type-subcontainer">
                                {{ pol?.displayType?.label | translate }}
                              </div>
  
                              <div class="contact-policy-type-content margin-bottom mb16">
                                {{pol?.policynumber?.policyNumber}}
                              </div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-template #bigScreen>
                      <ng-container *ngFor="let pol of policy" >
                        <div class="contact-policy-type-container">
                          <div class="contact-policy-type">
                            <div class="contact-policy-type-subcontainer">
                              {{ pol?.displayType?.label | translate }}
                            </div>

                            <div class="contact-policy-type-content">
                              {{pol?.policynumber?.policyNumber}}
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-template>
                    <div *ngIf="policy[0]?.agent?.agentISCPhone?.number" class="contact-details-hr"  [ngClass]="{'no-margin': policies?.length > 1 && !isSmallScreen}">
                    </div>
                    <div class="" *ngIf="policy[0]?.agent?.agentISCPhone?.number">
                      <div class="contact-agent-phone-title">
                        {{ "PHONE" | translate }}
                      </div>
                      <div class="lh-17">
                        <a href="tel:{{ policy[0]?.agent.agentISCPhone.number }}" class="contact-agent-phone-number">{{
                          policy[0]?.agent?.agentISCPhone?.number
                          | formatPhone
                          }}</a>
                      </div>
                    </div>
                    <div *ngIf="policy[0]?.agent?.agentPhone?.number && !policy[0]?.agent?.agentISCPhone?.number"
                      class="contact-details-hr"  [ngClass]="{'no-margin': policies?.length > 1 && !isSmallScreen}">
                    </div>
                    <div class=""
                      *ngIf="policy[0]?.agent?.agentPhone?.number && !policy[0]?.agent?.agentISCPhone?.number">
                      <div class="contact-agent-phone-title">
                        {{ "PHONE" | translate }}
                      </div>
                      <div class="lh-17">
                        <a href="tel:{{ policy[0]?.agent.agentPhone.number }}" class="contact-agent-phone-number">{{
                          policy[0]?.agent?.agentPhone?.number | formatPhone
                          }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="correspondence-container">
        <a class="faq-link-item" (click)="closeNonActiveCollapse('two')" mdbRipple
          [class.active]="accordianWithMDB.two">
          <div class="faq-item">
            <div class="correspondence-title">Mail a payment or correspondence</div>
            <div class="faq-arrow-block">
              <img src="assets/img/images/contact-icon-arrow-right.svg" *ngIf="!accordianWithMDB.two"
                alt="simple down arrow" />
              <img src="assets/img/images/contact-icon-arrow-down.svg" *ngIf="accordianWithMDB.two"
                alt="simple up arrow" />
            </div>
          </div>
        </a>
        <div class="contact-agent-info" #two [class.fake-accourdian]="!accordianWithMDB.two">
          <div class="contact-agent-info-hr"></div>
          <div class="">
            <div class="">
              <div class="correspondence-main">
                <div class="">
                  <h6 class="send-payment-title">
                    Send a payment
                  </h6>
                  <div class="address-container">
                    <div>
                      <div class="correspondence-company-name" [ngClass]="{'margin-bottom mb4': companyDomain === 'TW' || (((policyData[0]?.policynumber?.policyNumber?.length === 10 || companyDomain === 'AS400') &&  policyData?.jurisdiction?.state === 'MA' )  && (companyDomain === 'TW' || companyDomain === 'V12')), 'margin-bottom mb8': companyDomain === 'V12' || ( (policyData[0]?.policynumber?.policyNumber?.length === 10 && policyData[0]?.jurisdiction?.state === 'MA') && (!(companyDomain === 'TW' || companyDomain === 'V12')) &&  policies?.length > 1) || companyDomain === 'AS400'}">
                        {{ "COMPANY_NAME" | translate}}
                      </div>
                      <div class="correspondence-company-state" *ngIf="(hasAcicPolicy && hasTwPolicy) || (((policyData[0]?.policynumber?.policyNumber?.length === 10 || companyDomain === 'AS400') &&  policyData?.jurisdiction?.state === 'MA' )  && (companyDomain === 'TW' || companyDomain === 'V12'))">
                        {{ "FOR_OTHER_STATES_OUTSIDE_CALIFORNIA" | translate }}
                      </div>
                      <div class="correspondence-company-state" *ngIf="companyDomain === 'TW' && !hasAcicPolicy">
                        {{ "FOR_CALIFORNIA_POLICIES_ONLY" | translate }}
                      </div>
                      <ng-container *ngIf="(companyDomain === 'TW' || companyDomain === 'V12' || ( (policyData[0]?.policynumber?.policyNumber?.length === 10 && policyData[0]?.jurisdiction?.state === 'MA') && (!(companyDomain === 'TW' || companyDomain === 'V12')) &&  policies?.length > 1)) && !(hasAcicPolicy && hasTwPolicy)">
                        <div class="correspondence-company-address">{{ "POBOX_4" | translate }}</div>
                        <div class="correspondence-company-address">{{ "POBOX_5" | translate }}</div>
                      </ng-container>
                      <ng-container *ngIf="companyDomain === 'AS400' || (((policyData[0]?.policynumber?.policyNumber?.length === 10 || companyDomain === 'AS400') &&  policyData?.jurisdiction?.state === 'MA' )  && (companyDomain === 'TW' || companyDomain === 'V12')) || (hasAcicPolicy && hasTwPolicy)">
                        <div class="correspondence-company-address">{{ "POBOX_1" | translate }}</div>
                        <div class="correspondence-company-address">{{ "POBOX_2" | translate }}</div>
                      </ng-container>
                    </div>
                    <div *ngIf="(((policyData[0]?.policynumber?.policyNumber?.length === 10 || companyDomain === 'AS400') &&  policyData?.jurisdiction?.state === 'MA' )  && (companyDomain === 'TW' || companyDomain === 'V12')) || (hasAcicPolicy && hasTwPolicy)">

                      <div class="correspondence-company-name margin-bottom mb4">
                        {{ "COMPANY_NAME" | translate}}
                      </div>
                      <div class="correspondence-company-state">
                        {{ "FOR_CALIFORNIA_POLICIES_ONLY" | translate }}
                      </div>
                      <div class="correspondence-company-address">{{ "POBOX" | translate }}{{ "52234" }}</div>
                      <div class="correspondence-company-address">{{ "Phoenix, AZ 85072" }}</div>
                    </div>
                  </div>
                </div>

                <div class="correspondence-details-hr"></div>
                <div class="">
                  <h6 class="send-payment-title">
                    {{ "CORRESPONDENCE_TITLE" | translate }}
                  </h6>
                  <div class="correspondence-company-name margin-bottom mb8">
                    {{ "COMPANY_NAME" | translate}}
                  </div>
                  <div class="correspondence-company-address">
                    {{ "POBOX_3" | translate }}
                  </div>
                  <div class="correspondence-company-address">
                    {{ "ADDRESS_PART_TWO" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </section>
</mapfre-card>